/* window.fireEvent — the global event shim the LP fleet has been calling
   guarded (`typeof window.fireEvent === 'function'`) since 2026-05 without
   anyone ever defining it, so every CTA / add_to_cart / bump event silently
   no-opped (the "add_to_cart reads ~0" gap).

   Forwards to GA4 via the main-page gtag from snippets/ga4-gtag.liquid.

   EVERY event name is prefixed `lp_` before sending. This is load-bearing:
   the Google & YouTube channel's sandboxed pixel already owns the standard
   ecommerce events (add_to_cart, view_item, purchase...), and forwarding the
   fleet's `add_to_cart` verbatim would double-count against it. `lp_add_to_cart`,
   `lp_bump_accept`, `lp_bump_decline` etc. are our own custom event space.

   The quiz (sections/quiz-era.liquid) defines a LOCAL fireEvent in its own
   scope and is unaffected. Loaded from layout/theme.liquid, site-wide, right
   after the gtag snippet. */
(function () {
  'use strict';
  if (typeof window.fireEvent === 'function') return;
  window.fireEvent = function (name, params) {
    try {
      var raw = String(name || 'event');
      /* Some call sites already self-prefix (lp_meno_belly_view); don't double it. */
      var n = (raw.indexOf('lp_') === 0 ? raw : 'lp_' + raw).replace(/[^a-zA-Z0-9_]/g, '_').slice(0, 40);
      var p = {};
      var src = params || {};
      for (var k in src) {
        if (!Object.prototype.hasOwnProperty.call(src, k)) continue;
        var v = src[k];
        if (v === null || v === undefined) continue;
        p[String(k).replace(/[^a-zA-Z0-9_]/g, '_').slice(0, 40)] =
          (typeof v === 'object') ? JSON.stringify(v).slice(0, 100) : v;
      }
      p.page_path = window.location.pathname;
      if (typeof window.gtag === 'function') {
        /* Route explicitly to the Semaine property: third-party apps register
           their own gtag configs (a G-WSHTQCNVG3 tag was observed live), and an
           unrouted event broadcasts to every configured destination. */
        p.send_to = 'G-L024MLRK85';
        window.gtag('event', n, p);
      } else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(Object.assign({ event: n }, p));
      }
    } catch (e) { /* analytics must never break the page */ }
  };
})();
